import { RefundPassenger } from '../model/passengers/types';
import { getRefundChildIds } from './refundPassengerUtils';

/**
 * Выбранные пассажиры, сгруппированные по семейным связям.
 * - Выбран взрослый с детьми → одна семья (adult, children, children, ...).
 * - Выбран только ребенок → отдельная запись.
 * - Выбран взрослый → отдельная запись.
 */
export const getSelectedRefundFamiliesFromPassengers = (passengers: RefundPassenger[]): RefundPassenger[] => {
	const families: RefundPassenger[] = [];
	const processedChildIds = new Set<string>();

	for (const passenger of passengers) {
		if (processedChildIds.has(passenger.id)) {
			continue;
		}

		if (passenger.isSelected && passenger.children?.length) {
			families.push(passenger);
			getRefundChildIds(passenger).forEach(childId => processedChildIds.add(childId));
			continue;
		}

		if (!passenger.children?.length && passenger.isSelected) {
			families.push(passenger);
		}
	}

	return families;
};
